export default "__VITE_ASSET__Dhj8oRPb__"